module.exports = __webpack_public_path__ + "static/media/empty-avatar-icon.8bfbbb89.svg";